export const CheckTypeEnum = {
  id_verification: 'id_verification',
  id_document: 'id_document',
  aml: 'aml',
  company_monitoring: 'company_monitoring',
  document: 'document',
  electronic_signature: 'electronic_signature',
  online_reputation: 'online_reputation',
} as const;
export type CheckTypeEnum = (typeof CheckTypeEnum)[keyof typeof CheckTypeEnum];
